
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import { useNavigate, useLocation, BrowserRouter, Route, Routes } from "react-router-dom";
import { FirebaseAppProvider } from "reactfire";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/storage";
import firebaseConfig from "./firebase-config";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Login from "./components/Login";
import NewsForm from "./components/NewsForm";
import RegisterForm from "./components/RegisterForm";
import UsersAdmin from "./components/UsersAdmin";
import GalleryForm from "./components/GalleryForm";
import Index6 from "./Index6";

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const initialData = {
  titulo: "",
  imagen: "",
  fecha: "",
  descripcion: "",
};


const Root = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [data, setData] = useState(initialData);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        setIsAuth(true);
        // Verificar si es admin (por ejemplo, por email o rol en Firestore)
        // Aquí se asume admin si el email contiene 'admin', personaliza según tu lógica
        let admin = false;
        try {
          const db = firebase.firestore();
          const usuarios = await db.collection("usuarios").where("email", "==", user.email).get();
          if (!usuarios.empty) {
            const userData = usuarios.docs[0].data();
            admin = userData.rol === "admin" || user.email.includes("admin");
          }
        } catch (e) {
          // fallback simple
          admin = user.email && user.email.includes("admin");
        }
        setIsAdmin(admin);
        // Redirección automática tras login
        if (location.pathname === "/login") {
          if (admin) {
            navigate("/usuarios");
          } else {
            navigate("/");
          }
        }
      } else {
        setIsAuth(false);
        setIsAdmin(false);
      }
    });
    return () => unsubscribe();
  }, [navigate, location]);

  return (
    <Routes>
      <Route
        exact
        path={`${process.env.PUBLIC_URL}/`}
        element={<Index6 isAuth={isAuth} isAdmin={isAdmin} news={news} />}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/index-2`}
        element={<Index6 isAuth={isAuth} isAdmin={isAdmin} news={news} />}
      />
      <Route path={`${process.env.PUBLIC_URL}/login`} element={<Login />} />
      <Route
        path={`${process.env.PUBLIC_URL}/noticias`}
        element={
          <NewsForm
            isEdit={isEdit}
            isAdmin={isAdmin}
            loading={loading}
            news={news}
            data={data}
            //   handleEdit={handleEdit}
            //   handleDelete={handleDelete}
            //   handleChange={handleChange}
            //   handleSubmit={handleSubmit}
          />
        }
      />
      <Route
        path={`${process.env.PUBLIC_URL}/registro`}
        element={<RegisterForm />}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/usuarios`}
        element={<UsersAdmin isAdmin={isAdmin} />}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/galeria`}
        element={<GalleryForm isAdmin={isAdmin} />}
      />
    </Routes>
  );
};

ReactDOM.render(
  <FirebaseAppProvider firebaseConfig={firebaseConfig}>
    <BrowserRouter basename={"/"}>
      <Root />
      <ToastContainer />
    </BrowserRouter>
  </FirebaseAppProvider>,
  document.getElementById("root")
);
serviceWorker.unregister();
